import {Injectable} from '@angular/core';
import {tap} from 'rxjs/operators';
import {environment} from 'src/environments/environment';
import {HttpClient} from '@angular/common/http';
import {SharedService} from '../shared/shared-service';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  updateLoggedInUserInfo = new Subject<any>();

  constructor(private http: HttpClient, private sharedService: SharedService) {
  }

  signIn(loginData) {
    return this.http.post(environment.serverLink + '/login', loginData);
  }

  verifyOTP(userId: string, otp: string) {
    return this.http.post(environment.serverLink + '/verify-otp', { userId, otp });
  }

  resendOTP(userId: string) {
    return this.http.post(environment.serverLink + '/resend-otp', { userId });
  }

  getLoggedInUserMetaData() {
   return this.http.get(environment.serverLink + '/getLoggedInUserInfo', this.sharedService.generateHttpHeaders()).pipe(tap((res: any) => {
      sessionStorage.setItem('userInfo', JSON.stringify(res));
      this.updateLoggedInUserInfo.next(true);
      return res
    }));
  }

  changePasswordOnSession(dataToSend) {
    return this.http.post(environment.serverLink + '/changePassword', dataToSend, this.sharedService.generateHttpHeaders()).pipe(tap(result => {
      return result;
    }, error => {
      return error;
    }));
  }

  resetPasswordLink(email) {
    return this.http.post(environment.serverLink + '/emailsetpasswordlink', {email}).pipe(tap(result => {
      return result;
    }, error => {
      return error;
    }));
  }

  setPassword(data) {
    return this.http.post(environment.serverLink + '/setPassword', data).pipe(tap(result => {
      return result;
    }, error => {
      return error;
    }));
  }

    toggleMFA(userId: string, enable: boolean) {
    return this.http.post(environment.serverLink + '/toggle-mfa', { userId, enable });
  }

  // Check if user has MFA enabled
  checkMFAStatus(userId: string) {
    return this.http.get(environment.serverLink + '/mfa-status/' + userId);
  }

}
